<template>
  <div id="app">
    <header>
      <div id="header">
        <div id="logo"><a href="/"> <img src="@/assets/logo.jpg"/></a></div>
        <div id="serach">
            <el-input placeholder="请输入内容" v-model="input3"   class="input-with-select">
                <el-button slot="append" icon="el-icon-search" @click="onSearch()"></el-button>
            </el-input>
        </div>
        <div style="clear:both;"></div>
        <div id="menu">
          <ul>
            <router-link  v-for="(item,index) in nav" :key="index" :to="{name: item.name }" tag="li" @click.native="isClick(index)" :class="active==index?'aa':''" >{{item.title}}</router-link>
          </ul>
        </div>
        <div style="clear: both"></div>
      </div>

    </header>
    <Banner></Banner>
    <div id="index-content">
      <transition>
          <router-view/>
      </transition>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Banner from './components/common/Banner'
  import Footer from './components/common/Footer'
  
  export default {
    name: 'app',
    data () {
      return {
        nav: [
          { title: '首页', name: 'Home' },
          { title: '关于我们', name: 'About' },
          { title: '中国钱币', name: 'Country' },
          { title: '外国钱币', name: 'Overseas' },
          { title: '文化视野', name: 'Culture' },
          { title: '讨论社区', name: 'BBS' },
          { title: '使用指南', name: 'Use' },
          { title: '用户反馈', name: 'Feedback' }
        ],
        navIndex: 0,
        headerBarFixed: false,
        active:-1,
        input3:""
      }
    },
    components: {
      Banner,
      Footer
    },
    mounted () {
      // window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
        isClick(index){
          this.active=index
        },
        onSearch(){
          let so = this.input3;
          console.log(so);
          if(""==so){
            return;
          }
          this.$router.push({
              path: '/search',
              query: {
                so: so
              }
            })

        }
    }
  }
</script>
<style>
  #app{margin: 0 auto; background-color:#f7f7f7;width: 100%;min-width: 900px;}
header{height:128px;background: url('./assets/top_bg.jpg') center center no-repeat;width: 100%;}
#header{width: 900px;height: 128px;margin: 0 auto;overflow: hidden;;}
#header img{margin-top: 20px;}
#header ul{height: 32px; padding-left: 15px; width: 100%;background: url('./assets/menu_bg.jpg')  repeat-x; margin-top: 20px;font-size: 14px; font-family:url('./assets/pingfang.ttf');}
#header ul li{width: 100px; float: left; height: 32px; line-height: 32px; text-align: center; margin-right: 10px; cursor: pointer;}
#header ul li.bg{background: url('./assets/menu_li.jpg') center center no-repeat;}
#header ul li.aa{color:#A81824; background-color: antiquewhite;}
#index-content{width: 900px; margin: 0 auto;}
#logo{float: left;}
#serach{ width: 300px;   margin-top: 20px;float: right; } 
.input-with-select {
  width: 300px;
}
</style>
